var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotate-phone",attrs:{"role":"alert"}},[_vm._v(" Sorry, this app only works in portrait mode on your phone. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }